import { render, staticRenderFns } from "./problem-important.vue?vue&type=template&id=da2a29a0&scoped=true"
import script from "./problem-important.vue?vue&type=script&lang=js"
export * from "./problem-important.vue?vue&type=script&lang=js"
import style0 from "./problem-important.vue?vue&type=style&index=0&id=da2a29a0&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2a29a0",
  null
  
)

export default component.exports